import React, { useState, useRef, useEffect } from "react";
import "../assets/css/style.css";
import "../assets/css/responsive.css";
import "../assets/css/responsive1.css";
import "../assets/css/next.css";
import background from "../assets/img/popular-bg.png";
import Papa from "papaparse";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";

var Loader = require("react-loader");

const PopularTrips = () => {
  const [loaded, setLoaded] = useState(false);
  const [images, setImages] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(3);
  const [currentSlide, setCurrentSlide] = useState(0);

 useEffect(() => {
  const sheetURL =
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vQXuMDOBQtlDarzAAN6ve9PDZFnRdjaXRHOr9skFQYiuSKyL-RVrmnb17H3o5QMRR-0u09AbK5I_e2g/pub?output=csv";

  Papa.parse(sheetURL, {
    download: true,
    header: true,
    complete: (results) => {
      const cleanRows = results.data.filter((row) => row.travel);
      const parsedImages = cleanRows.map((row) => ({ src: row.travel }));
      setImages(parsedImages);
      setLoaded(true);
    },
  });
}, []);


  const [transitionEnabled, setTransitionEnabled] = useState(true);

  useEffect(() => {
    if (!transitionEnabled) {
      const timer = setTimeout(() => {
        setTransitionEnabled(true);
      }, 50);
      return () => clearTimeout(timer);
    }
  }, [transitionEnabled]);

  // Responsive items
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 767) setItemsPerPage(1);
      else if (window.innerWidth < 1024) setItemsPerPage(2);
      else setItemsPerPage(3);
    };
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Create extended list for seamless looping (append first page items to the end)
  const extendedImages = [...images, ...images.slice(0, itemsPerPage)];

  const nextSlide = () => {
    if (currentSlide >= images.length) return;
    setCurrentSlide((prev) => prev + 1);
    setTransitionEnabled(true);
  };

  const prevSlide = () => {
    const maxIndex = images.length - 1;
    setCurrentSlide((prev) => (prev <= 0 ? maxIndex : prev - 1));
  };

  const handleTransitionEnd = () => {
    if (currentSlide >= images.length) {
      setTransitionEnabled(false);
      setCurrentSlide(0);
    }
  };

  return (
    <>
      <div
        className="col-12 text-center hello"
        style={{
          backgroundImage: `linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0)), url(${background})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          paddingBottom: "5%",
        }}
      >
          <div className="row">
          <div className="tour-dreams">
            <h1 className="normal-text1" >
              Our Recent <span className='colGreen1'> Trips <p className='LineSVG1'> 
              <img src="images/line-vector.png" alt="vector"/> </p> </span>
            </h1>
          </div>
        </div>

        <Loader loaded={loaded}>
          <div className="container position-relative">
            <div className="row justify-content-center align-items-center flex-nowrap">

              {/* LEFT ARROW */}
              <div className="col-auto">
                <button
                  onClick={prevSlide}
                  className="border-0 bg-transparent text-white"
                  style={{ fontSize: "2rem" }}
                >
                  <FontAwesomeIcon icon={faChevronLeft} />
                </button>
              </div>

              {/* CAROUSEL WRAPPER */}
              <div className="col overflow-hidden px-0">
                <div
                  className="d-flex"
                  onTransitionEnd={handleTransitionEnd}
                  style={{
                    transition: transitionEnabled ? "transform 0.5s ease-in-out" : "none",
                    transform: `translateX(-${currentSlide * (100 / extendedImages.length)}%)`,
                    width: `${(extendedImages.length / itemsPerPage) * 100}%`,
                  }}
                >
                  {extendedImages.map((image, index) => (
                    <div
                      key={index}
                      className="poplur"
                    
                    >
                      <img
                        src={image.src}
                        className="popular-img"
                     
                      />
                    </div>
                  ))}
                </div>
              </div>

              {/* RIGHT ARROW */}
              <div className="col-2 col-md-1 text-center">
                <button
                  onClick={nextSlide}
                  className="border-0 bg-transparent text-white"
                  style={{ fontSize: "2rem" }}
                >
                  <FontAwesomeIcon icon={faChevronRight} />
                </button>
              </div>

            </div>
          </div>
        </Loader>
      </div>
    </>
  );
};

export default PopularTrips;
